import axios from "axios";

let controller;
let responsesData = [];

export async function getProductDetails(url, query) {

    if (responsesData[query]) {
        return responsesData[query];
    }

    if (controller) {
        controller.abort();
    }

    controller = new AbortController();

    try {
        const res = await axios
            .get(url + query,  {
                signal: controller.signal
            });

        responsesData[query] = res.data;
        return res.data;
    } catch (e) {
        return '';
    }
}